import {qspost,qspost2} from '@/plugins/axios'

/*
 * 用户登录
 * @constructor jack
 * */
export const userLogin = (user_name,password,type) => qspost('Home/Index/login', {user_name,password,type})

/*
 * 用户登录
 * @constructor jack
 * */
export const phoneLogin = (phone,code,sign,type) => qspost('Home/Index/sms_login', {phone,code,sign,type})


/*
 * 微信登录
 * @constructor jack
 * */
export const wxLogin = (code,type) => qspost('Home/Index/wx_login', {code,type})

/*
 * 发送短信验证码
 * @constructor jack
 * 1
 * */
export const sendSms = (phone,type) => qspost('Home/Index/sms_send', {phone,type})


/*
 * 忘记密码发送短信验证码
 * @constructor jack
 * 1
 * */
export const sendForgetSms = (phoneNum,type) => qspost('home/index/forgetUserSMS', {phoneNum,type})



/*
 * 忘记密码
 * @constructor jack
 * */
export const changeUserPassByPhoneCode = (phoneNum,phoneCode,newPass,newrPass) =>
    qspost('home/index/changeUserPassByPhoneCode', {phoneNum,phoneCode,newPass,newrPass})



/*
 * 获取会员申请信息表单
 * @constructor jack
 * 1
 * */
export const emofLogin = (emofUserTokenSafer) => qspost('/Home/Index/emof_login', {emofUserTokenSafer})





/*
 * 获取会员申请信息表单
 * @constructor jack
 * 1
 * */
export const getCompanyUserMoreJson = (mid) => qspost2('/home/Other/getCompanyUserMoreJson', {mid})


/*
 * 级别列表
 *  * @constructor jack
 * */
export const getApplyRankList = (mid) => qspost('/home/Other/getRankList', {mid})

/*
 * 会员管理-会员添加
 * userType  2个人  1机构
 * @constructor jack
 * */
export const memberApply = (userMoreJson,mid,userType) => qspost2('/home/Other/setUser', {userMoreJson,mid,userType})
